module.exports = __webpack_public_path__ + "static/media/user.2747d0ad.svg";